import { initToasts, initTooltips, initializePopovers } from "./util.js";

initTooltips(); // Allow BS tooltips
initToasts();
initializePopovers();
console.log("Basic scripts loaded");
